
import { SvgIcon } from '@mui/material'
import React from 'react'
// import icon from './svgs/memo-check.svg'
// import { BaseIcon } from './_base'

export const MemoIcon = ({sx,...props}) => {
    return (
        <SvgIcon {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: '#fff' } : sx, ...props }} >
            <path d="M7 7H11M13 17H17M7 10H17M7 13H17M7 17L7.85714 18L10 16M7.2 21H16.8C17.9201 21 18.4802 21 18.908 20.782C19.2843 20.5903 19.5903 20.2843 19.782 19.908C20 19.4802 20 18.9201 20 17.8V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.0799 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.07989 4 6.2V17.8C4 18.9201 4 19.4802 4.21799 19.908C4.40973 20.2843 4.71569 20.5903 5.09202 20.782C5.51984 21 6.07989 21 7.2 21Z"    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
